import { all, takeEvery } from "redux-saga/effects";
import { actionTypes as reservationActionTypes } from "./reducer";
import { createReservation, confirmReservation,
  getManageContent as getManageContentService } from "./service";
import processAction from "../../utils/processAction";

//get manage content
function* getManageContent(action) {
  yield processAction({
    ...action,
    service: getManageContentService,
    success: reservationActionTypes.GET_MANAGE_CONTENT_SUCCESS,
    failed: reservationActionTypes.GET_MANAGE_CONTENT_FAILED
  });
}

function* submitReservation(action) {
  yield processAction({
    ...action,
    service: createReservation,
    success: reservationActionTypes.SUBMIT_RESERVATION_SUCCESS,
    failed: reservationActionTypes.SUBMIT_RESERVATION_FAILED
  });
}

function* submitPaymentConfirmation(action) {
  yield processAction({
    ...action,
    service: confirmReservation,
    success: reservationActionTypes.RESERVATION_CONFIRMATION_SUCCESS,
    failed: reservationActionTypes.RESERVATION_CONFIRMATION_FAILED
  });
}

function* watcher() {
  yield all([
    //get manage contetn
    takeEvery(reservationActionTypes.GET_MANAGE_CONTENT,
      getManageContent),
    takeEvery(reservationActionTypes.SUBMIT_RESERVATION, submitReservation),
    takeEvery(
      reservationActionTypes.RESERVATION_CONFIRMATION,
      submitPaymentConfirmation
    )
  ]);
}

export default [watcher()];
